var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"layout-container-vertical fixed"},[_c('side-bar'),_c('div',{staticClass:"main"},[_c('div',{staticClass:"fixed-header"},[_c('nav-bar'),_c('tabs-bar')],1),_c('app-main')],1)],1),_c('el-backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }